import React, { useState, useCallback, useMemo } from "react";
import SampleTestRow from "./SampleTestRow";
import GroupedSampleTests from "./GroupedSampleTests";

export default function SampleTestsForTechnique({
  sample,
  sampleTests,
  showSample,
  selectedSampleTestIds,
  clientView = true,
  viewSingleSample,
  simpleSampleView
}) {
  const sortedSampleTests = useMemo(() => sampleTests.sort((a, b) => a.pos - b.pos), [
    sampleTests
  ]);
  // Only show initially collapsed if there are more than 10 results per technique
  // and there are no results
  const [collapsed, setCollapsed] = useState(sampleTests.length > 15);

  const canCollapse = sampleTests.length > 10;

  const toggleCollapse = useCallback(() => setCollapsed(!collapsed), [collapsed]);

  if (!collapsed) {
    return sortedSampleTests.map((sample_test, i) => {
      return (
        <SampleTestRow
          key={sample_test.id}
          clientView={clientView}
          sample={sample}
          sample={sample}
          sample_test={sample_test}
          showSample={showSample == false ? false : i == 0}
          showTechnique={i == 0}
          selected={selectedSampleTestIds.includes(sample_test.id)}
          collapseTechnique={sampleTests.length > 1 ? toggleCollapse : null}
          viewSingleSample={viewSingleSample}
          canCollapse={canCollapse}
          simpleSampleView={simpleSampleView}
        />
      );
    });
  }

  return (
    <GroupedSampleTests
      key={sample.sample.identifier}
      clientView={clientView}
      sample={sample}
      sample_tests={sortedSampleTests}
      showSample={showSample}
      canCollapse={canCollapse}
      collapseTechnique={sortedSampleTests.length > 0 ? toggleCollapse : null}
      selectedSampleTestIds={selectedSampleTestIds}
      viewSingleSample={viewSingleSample}
      simpleSampleView={simpleSampleView}
    />
  );
}
